// src/components/EntryModal.js
import React, { useContext, useState, useEffect } from "react";
import { LanguageContext } from "../context/LanguageContext";
import { useNavigate } from "react-router-dom";
import { apiRequest } from "../services/api";

function EntryModal({ isOpen, onClose }) {
  const { lang, toggleLanguage } = useContext(LanguageContext);
  const navigate = useNavigate();

  const [mode, setMode] = useState("choice");

  const [loginIdentifier, setLoginIdentifier] = useState("");
  const [loginName, setLoginName] = useState("");

  const [regPhone, setRegPhone] = useState("");
  const [regName, setRegName] = useState("");
  const [regEmail, setRegEmail] = useState("");

  const [loginIdTouched, setLoginIdTouched] = useState(false);
  const [regPhoneTouched, setRegPhoneTouched] = useState(false);

  const [uiError, setUiError] = useState("");

  const isEmail = (v = "") => v.includes("@");

 const formatLbLocal = (digits) => {
  // "DD DDD DDD"
  const d = digits.slice(0, 8);
  const p1 = d.slice(0, 2);
  const p2 = d.slice(2, 5);
  const p3 = d.slice(5, 8);
  return [p1, p2, p3].filter(Boolean).join(" ");
};

const formatLbPlus961 = (digitsAfter961) => {
  const d = digitsAfter961.slice(0, 8);
  const p1 = d.slice(0, 2);
  const p2 = d.slice(2, 5);
  const p3 = d.slice(5, 8);
  const parts = [p1, p2, p3].filter(Boolean).join(" ");
  return parts ? `+961 ${parts}` : `+961`;
};

const formatPhoneInput = (raw) => {
  const v = (raw || "").trim();

  // +961 flow
  if (v.startsWith("+961")) {
    const after = v.replace(/\s/g, "").slice(4);
    const digits = after.replace(/\D/g, "");
    return formatLbPlus961(digits);
  }

  // local LB numbers (70 / 71 / etc.)
  const firstChar = v.replace(/\s/g, "").charAt(0);
  if (firstChar === "0" || firstChar === "7" || firstChar === "8") {
    const digits = v.replace(/\D/g, "").slice(0, 8);
    return formatLbLocal(digits);
  }

  // otherwise (email / international) → do not format
  return raw;
};

const validatePhone = (value) => {
  const v = (value || "").trim();
  if (!v) return "Phone number is required.";

  // +961 Lebanon
  if (v.startsWith("+961")) {
    const all = v.replace(/\s/g, "");
    const digits = all.slice(4); // after +961
    if (!/^\d{8}$/.test(digits)) {
      return "Phone must be +961 followed by 8 digits.";
    }
    return null;
  }

  // Lebanese local (70 / 71 / 76 / etc.)
  const compact = v.replace(/\s/g, "");
  const firstChar = compact.charAt(0);
  if (firstChar === "0" || firstChar === "7" || firstChar === "8") {
    if (!/^\d{8}$/.test(compact)) {
      return "Phone must be exactly 8 digits.";
    }
    return null;
  }

  // International numbers (generic, strict enough)
  if (v.startsWith("+")) {
    const digits = v.replace(/\D/g, "");
    if (digits.length < 8 || digits.length > 15) {
      return "Invalid international phone number.";
    }
    return null;
  }

  return "Invalid phone number.";
};

 

  useEffect(() => {
    if (isOpen && localStorage.getItem("esill-open-login")) {
      setMode("login");
      localStorage.removeItem("esill-open-login");
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleClose = () => {
    setUiError("");
    setMode("choice");
    onClose();
  };

  const t = {
    EN: {
      welcome: "WELCOME TO LIONS",
      subtitle:
        "Access orders, wishlist, and exclusive offers.",
      login: "LOGIN",
      create: "CREATE ACCOUNT",
      continueGuest: "Continue as Guest",
      back: "Back",
      loginTitle: "Login",
      registerTitle: "Create Account",
      identifier: "Email or Phone",
      name: "Full Name",
      phone: "Phone Number",
      email: "Email (optional)",
      loginBtn: "LOGIN",
      registerBtn: "REGISTER",
    },
    AR: {
      welcome: "مرحباً بك في LIONS",
      subtitle:
        "سجّل للوصول إلى الطلبات والمفضلة والعروض.",
      login: "تسجيل الدخول",
      create: "إنشاء حساب",
      continueGuest: "المتابعة كزائر",
      back: "رجوع",
      loginTitle: "تسجيل الدخول",
      registerTitle: "إنشاء حساب",
      identifier: "البريد أو الهاتف",
      name: "الاسم الكامل",
      phone: "رقم الهاتف",
      email: "البريد الإلكتروني (اختياري)",
      loginBtn: "دخول",
      registerBtn: "تسجيل",
    },
  }[lang];

  const handleSubmit = async () => {
  try {
    setUiError("");

    if (mode === "login") {
      if (!loginIdentifier || !loginName) {
        setUiError("Missing login info");
        return;
      }

      const res = await apiRequest("/auth/login", {
        method: "POST",
        body: JSON.stringify({
          identifier: loginIdentifier.trim(),
          full_name: loginName.trim(),
        }),
      });

      localStorage.setItem("esill-token", res.token);
      localStorage.setItem("esill-user", JSON.stringify(res.user));

      handleClose();
      window.location.reload(); // ✅ refresh app state safely
    }

    if (mode === "register") {
      const phoneError = validatePhone(regPhone);
if (phoneError) {
  setUiError(phoneError);
  return;
}

if (!regName) {
  setUiError("Full name is required");
  return;
}


      const res = await apiRequest("/auth/register", {
  method: "POST",
  body: JSON.stringify({
    full_name: regName.trim(),
    phone: regPhone.trim(),   // ✅ keep spaces
    email: regEmail || null,
  }),
});


      localStorage.setItem("esill-token", res.token);
      localStorage.setItem("esill-user", JSON.stringify(res.user));

      handleClose();
      window.location.reload(); // ✅ refresh app state safely
    }
  } catch (err) {
    setUiError(err.message || "Authentication failed");
  }
};

const isLoginDisabled =
  !loginIdentifier || !loginName;

const isRegisterDisabled =
  !regName || !!validatePhone(regPhone);



  return (
    <div
      className={`
        fixed inset-0 z-[99999]
        flex items-center justify-center
        bg-black/70 backdrop-blur-md
        ${isOpen ? "opacity-100" : "opacity-0"}
      `}
      dir={lang === "AR" ? "rtl" : "ltr"}
    >
      {/* CLOSE */}
      <button
        onClick={handleClose}
        className={`absolute top-6 text-3xl text-white
          ${lang === "EN" ? "right-6" : "left-6"}
        `}
      >
        ×
      </button>

      {/* LANGUAGE */}
      <button
  onClick={toggleLanguage}
  className={`absolute top-6
    ${lang === "EN" ? "left-6" : "right-6"}
    text-xs px-3 py-1.5 rounded-full
    bg-black text-white
    border border-[#2E5A2A]
    shadow-md
    hover:bg-[#2E5A2A] hover:text-white
    active:scale-95
    transition
  `}
>
  {lang === "EN" ? "AR" : "EN"}
</button>


      {/* MODAL */}
      <div
        className="
          relative w-[90%] max-w-sm
          bg-black text-white
          border border-[#2E5A2A]/40
          shadow-[0_0_30px_rgba(46,150,42,0.35)]
          px-6 py-8
          animate-slideUp
        "
      >
        <div className="absolute inset-0 hud-grid opacity-15 pointer-events-none" />

        {mode === "choice" && (
          <>
            <h2 className="text-lg font-bold tracking-widest text-center">
              {t.welcome}
            </h2>
            <p className="text-sm text-center text-white/70 mt-3 mb-6">
              {t.subtitle}
            </p>

            <button
              onClick={() => setMode("login")}
              className="
                w-full py-3 mb-3
                bg-[#2E5A2A] font-semibold
                hover:bg-[#234620] transition
              "
            >
              {t.login}
            </button>

            <button
              onClick={() => setMode("register")}
              className="
                w-full py-3
                border border-[#2E5A2A]
                hover:bg-[#2E5A2A]/20 transition
              "
            >
              {t.create}
            </button>

            <button
              onClick={handleClose}
              className="block mx-auto mt-6 text-xs underline text-white/60"
            >
              {t.continueGuest}
            </button>
          </>
        )}

        {(mode === "login" || mode === "register") && (
          <>
            <button
              onClick={() => setMode("choice")}
              className="text-xs text-white/60 mb-4"
            >
              ← {t.back}
            </button>

            <h2 className="font-semibold mb-4">
              {mode === "login" ? t.loginTitle : t.registerTitle}
            </h2>

            <form
  className="space-y-3"
  onSubmit={(e) => {
    e.preventDefault();
    handleSubmit();
  }}
>
{mode === "login" && (
  <>
    <input
  type="text"
  value={loginIdentifier}
  onChange={(e) => {
    const next = e.target.value;

    // Email → do not format
    if (isEmail(next)) {
      setLoginIdentifier(next);
      return;
    }

    // Phone → force format
    setLoginIdentifier(formatPhoneInput(next));
  }}
  className="w-full bg-black border border-[#2E5A2A]/50 px-3 py-2 text-sm"
  placeholder={t.identifier}
/>


    <input
      value={loginName}
      onChange={(e) => setLoginName(e.target.value)}
      className="w-full bg-black border border-[#2E5A2A]/50 px-3 py-2 text-sm"
      placeholder={t.name}
    />
  </>
)}

{mode === "register" && (
  <>
    <input
  value={regPhone}
  onChange={(e) => setRegPhone(formatPhoneInput(e.target.value))}
  onBlur={() => setRegPhoneTouched(true)}
  className="w-full bg-black border border-[#2E5A2A]/50 px-3 py-2 text-sm"
  placeholder={t.phone}
/>

{regPhoneTouched && validatePhone(regPhone) && (
  <div className="text-red-400 text-xs mt-1">
    {validatePhone(regPhone)}
  </div>
)}


    <input
      value={regName}
      onChange={(e) => setRegName(e.target.value)}
      className="w-full bg-black border border-[#2E5A2A]/50 px-3 py-2 text-sm"
      placeholder={t.name}
    />

    <input
      value={regEmail}
      onChange={(e) => setRegEmail(e.target.value)}
      className="w-full bg-black border border-[#2E5A2A]/50 px-3 py-2 text-sm"
      placeholder={t.email}
    />
  </>
)}


              {uiError && (
                <div className="text-red-400 text-xs">{uiError}</div>
              )}

              {mode === "login" && (
  <button
    type="submit"
    disabled={isLoginDisabled}
    className={`
      w-full py-3 mt-4 font-semibold
      ${
        isLoginDisabled
          ? "bg-gray-600 cursor-not-allowed"
          : "bg-[#2E5A2A] hover:bg-[#234620]"
      }
      transition
    `}
  >
    {t.loginBtn}
  </button>
)}

{mode === "register" && (
  <button
    type="submit"
    disabled={isRegisterDisabled}
    className={`
      w-full py-3 mt-4 font-semibold
      ${
        isRegisterDisabled
          ? "bg-gray-600 cursor-not-allowed"
          : "bg-[#2E5A2A] hover:bg-[#234620]"
      }
      transition
    `}
  >
    {t.registerBtn}
  </button>
)}


            </form>
          </>
        )}
      </div>

      <style>{`
        @keyframes slideUp {
          from { transform: translateY(40px); opacity: 0 }
          to { transform: translateY(0); opacity: 1 }
        }
        .animate-slideUp {
          animation: slideUp .45s ease-out;
        }
      `}</style>
    </div>
  );
}

export default EntryModal;
